<template>
  <div>
    <vs-input v-validate="'required|min:3'" data-vv-validate-on="blur" name="email" icon-no-border icon="icon icon-user"
      icon-pack="feather" label-placeholder="Email address of Username" v-model="email" class="w-full" />
    <span class="text-danger text-sm">{{ errors.first("email") }}</span>

    <!-- <vs-input
        v-validate="'required|email|min:3'"
        data-vv-validate-on="blur"
        name="email"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Email address of Username"
        v-model="email"
        class="w-full"/>
    <span class="text-danger text-sm">{{ errors.first('email') }}</span> -->
    <br />
    <div style="display: flex">
      <vs-input id="passwordBox" autocomplete="off" data-vv-validate-on="blur" v-validate="'required|min:6|max:10'"
        :type="showPassword" name="password" icon-no-border icon="icon icon-lock" icon-pack="feather"
        label-placeholder="Password" v-model="password" class="w-full mt-6" />
      <feather-icon @click="showHidePassword()" :icon="eye" class="cursor-pointer ml-3"
        style="top: 10px"></feather-icon>
    </div>

    <span class="text-danger text-sm">{{ errors.first("password") }}</span>
    <div class="flex flex-wrap justify-between my-5">
      <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
        <router-link to="/pages/forgot-password">Forgot Password?</router-link> -->
    </div>
    <!-- <vs-button  type="border" @click="registerUser">Register</vs-button> -->
    <vs-button ref="login" class="rounded-lg w-full mt-6" :disabled="!(email && password)"
      @click="login">Login</vs-button>

    <vs-divider>www.fams.co.za</vs-divider>
    <vs-popup title="Notice" class="w-full pl-20 pr-20 pt-4 pb-4" id="Popup" :active.sync="showAlert">
      <div id="PMessage">
        <div id="MessagePopup" ref="popupMessage">
          <h5 style="text-align: left">
            <p><strong>Subject:</strong> Service Notice – Ticketing System Interruption</p>
            <p><br></p>
            <p>Dear Valued Client,</p>
            <p><br></p>
            <p>First and foremost, we at Tecmo Automation would like to express our sincere gratitude for your continued
              support and for choosing our FAMS fuel management systems. We greatly value your partnership and look
              forward to maintaining a strong working relationship with you.</p>
            <p>We apologize for the inconvenience. Our ticketing system is currently experiencing technical issues, and
              we are actively working to resolve the matter in collaboration with our ticketing service provider.</p>
            <p><br></p>
            <p>Should you require immediate assistance, please do not hesitate to contact our office at 016 931 1958.</p>

            <p>Thank you for your understanding and patience.</p>

            <p>Kind regards,</p>
            <p><strong>FAMS Division Team</strong></p>
            <p><strong>Tecmo Automation</strong></p>
          </h5>
        </div>
      </div>
      <div>
        <vs-button class="rounded-lg mr-2" color="black" style="float: right" type="filled" @click="closePopup()">
          Close
        </vs-button>
      </div>
    </vs-popup>
    <vs-popup title="Notice" class="w-full pl-20 pr-20 pt-4 pb-4" id="Popup" :active.sync="showPopup">
      <div id="PMessage">
        <div id="MessagePopup" ref="popupMessage">
          <h5 style="text-align: left">
            <p>Dear FAMS client</p>
            <p>
              We trust you are well.<br />
              Thank you for the continuous support throughout 2021. We sincerely
              appreciate it.<br /><br />
            </p>
            <p>
              Please take note of the following arrangements:<br />
              &bull; Due to a recent influx of COVID-related afflictions
              affecting our staff, our direct operating times have become
              limited. All issues must be communicated by logging a ticket or
              emailing support@tecmo.freshdesk.com<br />
              &bull; Our offices will be closed from 15 Dec &ndash; 5 Jan<br />
              &bull; In case of emergency, use the system in override<br />
              &bull; The cloud server hosting the FAMS (Legacy) Reports is
              experiencing major connectivity issues due to constant
              loadshedding/ power outage/ covid-19 etc<br />
              &bull; We strongly recommend clients start using FAMS Report which
              became active in Jan 2021. Please note, Under the Custom/Scheduled
              Reports menu item, please select the FAMS Report menu item instead
              of the FAMS (Legacy) Reports<br />
              &bull; Please log a ticket if any legacy report is not available
              under FAMS Report or if the data is not updating<br />
            </p>
            <p>
              &bull; Please take note that support for the Syncfusion app has
              ended, download the all new FAMSxpress app:<br />
              &rdsh; Google Play<br />
              &rarrhk;
              https://play.google.com/store/apps/details?id=fams.company.app<br />
              &rdsh; Huawei App Gallery<br />
              &rarrhk; https://appgallery.huawei.com/app/C104807123<br />
              &rdsh; Apple App Store<br />
              &rarrhk; https://apps.apple.com/za/app/famsxpress/id1589019185
            </p>

            <p>
              Enjoy the festive season!<br />
              Kind regards,<br />
              The FAMS team.
            </p>
          </h5>
        </div>
      </div>
      <div>
        <vs-button class="rounded-lg mr-2" color="black" style="float: right" type="filled" @click="closePopup()">
          Close
        </vs-button>
      </div>
    </vs-popup>
    <vs-popup title="Notice" class="w-full pl-20 pr-20 pt-4 pb-4" id="Popup" :active.sync="showPopupYearEnd">
      <div id="PMessage" class="year-end-popup">
        <div id="MessagePopup" ref="popupMessage">

          <h3 class="title">Year-End Message and Important Dates</h3>

          <p><strong>Dear Valued Customer,</strong></p>

          <p>
            As 2025 draws to a close, we would like to extend our warmest wishes to you
            and your family for a joyful festive season. May the new year bring you good
            health, happiness, and prosperity. For those traveling, we wish you a safe journey.
          </p>

          <p>
            We would also like to take this opportunity to sincerely thank you for your
            continued support throughout 2025.
          </p>

          <p><strong>Please note the following important dates:</strong></p>

          <ul class="dates">
            <li>We will close at 13:00 on <strong>19 December 2025</strong>.</li>
            <li>Business will resume on <strong>12 January 2026</strong>.</li>
          </ul>

          <p class="footer">
            We look forward to another successful year together and an exciting 2026 ahead.
          </p>

          <p class="fams-heading">For all our existing FAMS Portal customers :</p>

          <p class="fams-instructions">
            PLEASE ESCALATE ANY ENQUIRIES THROUGH THE TICKET SYSTEM ON THE FAMS PORTAL.<br />
            ALL TICKETS WILL BE CHECKED DAILY BY THE SELECTED ON-CALL STAFF.
          </p>

          <p class="fams-instructions">
            FOR FAMS SITE SUPPORT, WE REQUEST THAT YOU DO NOT WHATSAPP, PHONE OR EMAIL
            YOUR REPRESENTATIVES – THE FAMS PORTAL WILL BE THE ONLY CHANNEL MONITORED
            CONSTANTLY AS STAFF LEAVE HAS BEEN ROTATED TO ALSO ENJOY THE HOLIDAY SEASON.
          </p>

          <p class="nb">
            NB: PLEASE CIRCULATE THIS ADVICE TO ALL PROCUREMENT STAFF AND ANY OTHER RELEVANT PERSONS IN YOUR COMPANY.
          </p>
        </div>
      </div>

      <div>
        <vs-button class="rounded-lg mr-2" color="black" style="float: right" type="filled" @click="closePopupYearEnd()">
          Close
        </vs-button>
      </div>
    </vs-popup>

  </div>
</template>

<script>

export default {
  data() {
    return {
      email: "",
      password: "",
      checkbox_remember_me: false,
      showPassword: "password",
      eye: "EyeIcon",
      showPopup: false,
      showPopupYearEnd: false,
      showAlert: false,
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email != "" && this.password != "";
    },
  },
  mounted() {
    var self = this;
    // self.openPopupYearEnd();
    // self.openPopupMessage();
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem("isUser", "false");
    localStorage.setItem("Current_User_Id", "");
    window.addEventListener(
      "keyup",
      function (event) {
        if (event.keyCode === 13 && self.email && self.password) self.login();
      },
      false
    );
  },
  methods: {
    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: "Login Attempt",
          text: "You are already logged in!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });

        return false;
      }
      return true;
    },
    login() {
      localStorage.setItem("userInfo", "");
      this.showLoadingOnButton();

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password,
        },
        notify: this.$vs.notify,
        self: this,
      };
      this.$vs.loading.close(this.$refs.login.$el);
      window.removeEventListener("keyup", this.eventListenerFunc, false);
      this.$store.dispatch("auth/loginAttempt", payload);
      // this.closeLoader();
    },
    closeLoader(){
      this.$vs.loading.close(this.$refs.login.$el);
    },
    notifyAlreadyLogedIn() {
      this.stopLoading();
      this.$vs.notify({
        title: "Login Attempt",
        text: "You are already logged in!",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning",
      });
    },
    showLoadingOnButton() {
      var self = this;
      self.$vs.loading({
        type: "material",
        container: self.$refs.login.$el,
        scale: 0.45,
      });
    },
    showHidePassword() {
      if (this.showPassword == "password") {
        this.showPassword = "text";
        this.eye = "EyeOffIcon";
      } else {
        this.showPassword = "password";
        this.eye = "EyeIcon";
      }
    },
    openPopupMessage() {
      var self = this;
      self.showAlert = true;
      self.showPopup = false;
    },
    openPopupYearEnd() {
      var self = this;
      self.showPopupYearEnd = true;
      self.showPopup = false;
    },
    closePopup() {
      var self = this;
      self.showPopup = false;
      // self.showPopupYearEnd = false;
      self.showAlert = false;
    },
    closePopupYearEnd() {
      var self = this;
      self.showPopupYearEnd = false;
      self.showPopup = false;
    },
  },
};
</script>


<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>

<style>
.year-end-popup {
  font-family: "Times New Roman", Times, serif;
  position: relative;
  padding: 20px;
}

.year-end-popup .title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}

.year-end-popup p {
  font-size: 14px;
  line-height: 1.45;
  margin: 10px 0;
}

.year-end-popup ul.dates {
  list-style-type: disc;
  margin-left: 25px;
}

.year-end-popup ul.dates li {
  font-size: 14px;
  margin: 6px 0;
}

.year-end-popup .fams-heading {
  color: #d40000;
  font-weight: bold;
  margin-top: 18px;
}

.year-end-popup .fams-instructions {
  text-transform: uppercase;
  font-size: 13px;
  line-height: 1.4;
  margin-bottom: 10px;
}

.year-end-popup .nb {
  font-weight: bold;
  margin-top: 10px;
  font-size: 14px;
}

/* Optional: faint background watermark like the HTML page */
.year-end-popup::before {
  content: "";
  position: absolute;
  inset: 0;
  background: url('/path/to/watermark.png') center/300px no-repeat;
  opacity: 0.08;
  pointer-events: none;
}
</style>
